import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfigurationService } from '../../services/configuration.service';
import { InpageAliasService } from '../../services/inpage-alias.service';
import { ReportNewClaimComponent } from '../report-new-claim/report-new-claim.component';
import { Aliases } from '../../models/aliases';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-new-claim',
    template: `
    <app-panel
      [attr.title]="reportClaimLabel"
      [flat]="flat"
      [showTitle]="!hideExpand"
      [headerLevel]="2"
    >
      <div class="tw-flex">
        <img
          src="./assets/images/newclaim.webp"
          height="79"
          width="79"
          alt=""
        />
        <div>
          <p class="app-pl2">
            {{ startNewClaimHeading }}
            <a [routerLink]="" (click)="reportClaim()"><b>clicking here.</b></a>
          </p>
        </div>
      </div>
    </app-panel>
  `,
    styles: [``],
    standalone: false
})
export class NewClaimComponent implements OnInit {
  @Input()
  flat = false;

  @Input()
  hideExpand = false;

  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });

  reportClaimLabel: string = '';
  startNewClaimHeading: string;

  constructor(
    public dialog: MatDialog,
    public claimConfigService: ConfigurationService,
    public inpageAliasService: InpageAliasService
  ) {}

  async ngOnInit() {
    this.reportClaimLabel = await this.inpageAliasService.get('ReportClaim');
    if (this.reportClaimLabel == 'Report a new claim') {
      this.startNewClaimHeading =
        'Need to report a new claim? You can start a new claim by';
    } else {
      this.startNewClaimHeading =
        'Need to ' + this.reportClaimLabel + '? You can start a new claim by';
    }
  }

  reportClaim() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Confirmation',
    };
    this.dialog.open(ReportNewClaimComponent, dialogConfig);
  }
}
